import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const CanchaSimpleIcon = props => {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <SvgIcon {...props} viewBox="0 0 47.162 35.924">
      <path
        id="Trazado_80"
        data-name="Trazado 80"
        d="M43.017,61H4.145A4.15,4.15,0,0,0,0,65.145V92.779a4.15,4.15,0,0,0,4.145,4.145H43.017a4.15,4.15,0,0,0,4.145-4.145V65.145A4.15,4.15,0,0,0,43.017,61ZM2.763,72.054H6.909A1.383,1.383,0,0,1,8.29,73.435V84.489a1.383,1.383,0,0,1-1.382,1.382H2.763ZM22.2,94.161H4.145a1.383,1.383,0,0,1-1.382-1.382V88.634H6.909a4.15,4.15,0,0,0,4.145-4.145V73.435A4.15,4.15,0,0,0,6.909,69.29H2.763V65.145a1.383,1.383,0,0,1,1.382-1.382H22.2v8.429a6.909,6.909,0,0,0,0,13.539Zm-2.763-15.2a4.145,4.145,0,1,1,4.145,4.145A4.15,4.15,0,0,1,19.436,78.962ZM44.4,85.871H40.254a1.383,1.383,0,0,1-1.382-1.382V73.435a1.383,1.383,0,0,1,1.382-1.382H44.4Zm0-16.581H40.254a4.15,4.15,0,0,0-4.145,4.145V84.489a4.15,4.15,0,0,0,4.145,4.145H44.4v4.145a1.383,1.383,0,0,1-1.382,1.382H24.963V85.732a6.909,6.909,0,0,0,0-13.539V63.763H43.017A1.383,1.383,0,0,1,44.4,65.145Z"
        transform="translate(0 -61)"
      />
    </SvgIcon>
  );
};

export default CanchaSimpleIcon;
